module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/customer/customer-grid/customer-grid.component.css
// module id = ./src/app/recovery/customer/customer-grid/customer-grid.component.css
// module chunks = main